import { useTranslations } from "next-intl";

import { Icon } from "@zapier/zinnia-icons";
import { Link } from "@zapier/design-system";

import { routes } from "@/reporting/constants";

export function NotificationSettingsButton() {
  const t = useTranslations("history-page");

  return (
    <Link
      href={routes.notifications}
      variant="tertiary"
      size="medium"
      iconPosition="start"
    >
      <Icon name="navBell" />
      {t("notification-settings")}
    </Link>
  );
}
